import request from "helpers/api_helper";
// import getFormData from "Components/Form/Formdata";
import { toast } from "react-toastify";


export const updateProfile = async (reqData) => {
    // console.log('reqData', reqData)
    // const formData = getFormData(reqData);
    try {
        const token = localStorage.getItem('token');
        const args = {
            url: "update_profile",
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(reqData), 
        };
        const data = await request(args);
        if (data?.success) {
            toast.success(data.message);
        }
        return data; 
    } catch (error: any) {
        toast.error(error.message);
        return error; 
    }
}

export const changePassword = async (reqData) => {
    try {
        const token = localStorage.getItem('token');
        const args = {
            url: "change_password",
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(reqData), 
        };
        const data = await request(args);
        if (data?.success) {
            toast.success(data.message);
        }
        return data; 
    } catch (error: any) {
        toast.error(error.message);
        return error; 
    }
}